import { db } from '../firebase';
import { collection, doc, setDoc, getDocs } from 'firebase/firestore';
import { categories } from './categories';

/**
 * Database seeding script for categories
 * This script populates the Firebase Firestore database with the hierarchical category structure
 */
export const seedCategories = async () => {
  try {
    console.log('Starting category seeding...');
    
    // Create categories collection reference
    const categoriesCollection = collection(db, 'categories');
    
    // Seed each category
    for (const category of categories) {
      const categoryDocRef = doc(categoriesCollection, category.categoryId);
      
      await setDoc(categoryDocRef, {
        categoryId: category.categoryId,
        categoryName: category.categoryName,
        description: category.description,
        subCategories: category.subCategories,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      });
      
      console.log(`✅ Seeded category: ${category.categoryName}`);
    }
    
    console.log('🎉 Category seeding completed successfully!');
    console.log(`📊 Total categories seeded: ${categories.length}`);
    
  } catch (error) {
    console.error('❌ Error seeding categories:', error);
    throw error;
  }
};

/**
 * Function to check if categories already exist in the database
 */
export const checkCategoriesExist = async () => {
  try {
    const categoriesCollection = collection(db, 'categories');
    const snapshot = await getDocs(categoriesCollection);
    return !snapshot.empty;
  } catch (error) {
    console.error('Error checking categories:', error);
    return false;
  }
};

/**
 * Safe seeding function that checks if categories already exist
 */
export const safeSeedCategories = async () => {
  try {
    const categoriesExist = await checkCategoriesExist();
    
    if (categoriesExist) {
      console.log('⚠️ Categories already exist in database. Skipping seeding.');
      return;
    }
    
    await seedCategories();
  } catch (error) {
    console.error('Error in safe seeding:', error);
  }
};

// Export for use in development or admin tools
export default seedCategories; 